<template>
  <div class="h-full">
    <slot v-if="unlocked" />

    <div v-if="!unlocked && owner" :class="baseClass">
      <div class="text-center">
        <h2 class="font-bold text-secondary text-xl tracking-tight mb-2">
          {{ $t('components.elements.paywall.notAvailable', { label: label || metaName }) }}
        </h2>
        <p class="opacity-70 mb-8">
          {{ $t('components.elements.paywall.upgrade', { label: label || metaName }) }}
        </p>
        <o-button to="/account">
          {{ $t('components.elements.paywall.changePlan') }}
        </o-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const instance = getCurrentInstance()
const route = useRoute()

interface Props {
  label?: string | null
  features?: any[] | null
  baseClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  label: null,
  features: null,
  baseClass: 'h-full w-full absolute inset-0 flex items-center justify-center bg-white dark:bg-gray-900',
})

const unlocked = computed(() => {
  let features: any = null

  if (props.features) {
    features = props.features
  } else if (route.path) {
    const path = route.path
    features = instance?.proxy?.$features.route(path)
  }

  if (!features) {
    return true
  }

  const allowed = instance?.proxy?.$features.all(features)

  return allowed
})

const owner = computed(() => {
  const employee = instance?.proxy?.$auth.info.employee
  return employee.role.isRoleTypeOwner
})

const metaName = computed(() => {
  return instance?.proxy?.$t('components.elements.paywall.thisFeature')
})
</script>
